// Common
import CommonPostSettings from "@/components/posts/CommonPostSettings.vue";
// Html
import HtmlRender from "@/components/posts/html/HtmlRender.vue";
import HtmlForm from "@/components/posts/html/HtmlForm.vue";
import HtmlStyle from "@/components/posts/html/HtmlStyle.vue";
// Grab
import GrabRender from "@/components/posts/grab/GrabRender.vue";
import GrabForm from "@/components/posts/grab/GrabForm.vue";
// Rss
import RssRender from "@/components/posts/rss/RssRender.vue";
import RssForm from "@/components/posts/rss/RssForm.vue";
import RssStyle from "@/components/posts/rss/RssStyle.vue";
// Date
import DateForm from "@/components/posts/date/DateForm.vue";
import DateRender from "@/components/posts/date/DateRender.vue";
import DateStyle from "@/components/posts/date/DateStyle.vue";
import { DateFormats, Languages } from "@/services/posts/postTypes/date";
// Image
import ImageRender from "@/components/posts/image/ImageRender.vue";
import ImageForm from "@/components/posts/image/ImageForm.vue";
import ImageStyle from "@/components/posts/image/ImageStyle.vue";
import ImageSettings from "@/components/posts/image/ImageSettings.vue";

// Video
import VideoRender from "@/components/posts/video/VideoRender.vue";
import VideoForm from "@/components/posts/video/VideoForm.vue";
import VideoStyle from "@/components/posts/video/VideoStyle.vue";
import VideoSettings from "@/components/posts/video/VideoSettings.vue";
// MeetingList
// import MeetingListRender from "@/components/posts/meetingList/MeetingListRender.vue";
// import MeetingListForm from "@/components/posts/meetingList/MeetingListForm.vue";
// import MeetingListStyle from "@/components/posts/meetingList/MeetingListStyle.vue";
// Folder
import FolderForm from "@/components/posts/folder/FolderForm.vue";
import FolderStyle from "@/components/posts/folder/FolderStyle.vue";
import FolderSettings from "@/components/posts/folder/FolderSettings.vue";

// Clock
import ClockForm from "@/components/posts/clock/ClockForm.vue";
import ClockRender from "@/components/posts/clock/ClockRender.vue";
import ClockStyle from "@/components/posts/clock/ClockStyle.vue";
import { ClockFormats, HourFormatEnum } from "@/services/posts/postTypes/clock";

// Wayfinder
import WayfinderForm from "@/components/posts/wayfinder/WayfinderForm.vue";
import WayfinderRender from "@/components/posts/wayfinder/WayfinderRender.vue";
import WayfinderStyle from "@/components/posts/wayfinder/WayfinderStyle.vue";

// FixedHtml
import FixedHtmlForm from "@/components/posts/fixedHtml/FixedHtmlForm.vue";
import FixedHtmlRender from "@/components/posts/fixedHtml/FixedHtmlRender.vue";
import FixedHtmlStyle from "@/components/posts/fixedHtml/FixedHtmlStyle.vue";

import i18n from "@/i18n";
import { Component } from "vue";

// constants
export const renderSufix = "Render";
export const formSufix = "Form";
export const styleSufix = "Style";
export const settingsSufix = "Settings";

// postTypes data structure
export const postTypes = {
    Grab: {
        RenderComponent: GrabRender,
        FormComponent: GrabForm,
        StyleComponent: {} as Component,
        SettingsComponent: null
    },
    Html: {
        RenderComponent: HtmlRender,
        FormComponent: HtmlForm,
        StyleComponent: HtmlStyle,
        SettingsComponent: CommonPostSettings
    },
    RSS: {
        RenderComponent: RssRender,
        FormComponent: RssForm,
        StyleComponent: RssStyle,
        SettingsComponent: CommonPostSettings
    },
    // MeetingList: {
    //     RenderComponent: MeetingListRender,
    //     FormComponent: MeetingListForm,
    //     StyleComponent: MeetingListStyle
    // },
    Date: {
        RenderComponent: DateRender,
        FormComponent: DateForm,
        StyleComponent: DateStyle,
        SettingsComponent: CommonPostSettings
    },
    Image: {
        RenderComponent: ImageRender,
        FormComponent: ImageForm,
        StyleComponent: ImageStyle,
        SettingsComponent: ImageSettings
    },
    Video: {
        RenderComponent: VideoRender,
        FormComponent: VideoForm,
        StyleComponent: VideoStyle,
        SettingsComponent: VideoSettings
    },
    Folder: {
        RenderComponent: {},
        FormComponent: FolderForm,
        StyleComponent: FolderStyle,
        SettingsComponent: FolderSettings
    },
    Clock: {
        RenderComponent: ClockRender,
        FormComponent: ClockForm,
        StyleComponent: ClockStyle,
        SettingsComponent: CommonPostSettings
    },
    Wayfinder: {
        RenderComponent: WayfinderRender,
        FormComponent: WayfinderForm,
        StyleComponent: WayfinderStyle,
        SettingsComponent: CommonPostSettings
    },
    FixedHtml: {
        RenderComponent: FixedHtmlRender,
        FormComponent: FixedHtmlForm,
        StyleComponent: FixedHtmlStyle,
        SettingsComponent: CommonPostSettings
    }
};

// methods
function renderComponentsFn() {
    const components: { [key: string]: Component } = {};
    for (const [key, value] of Object.entries(postTypes)) {
        components[key.concat(renderSufix)] = value.RenderComponent;
    }
    return components;
}

function formComponentsFn() {
    const components: { [key: string]: Component } = {};
    for (const [key, value] of Object.entries(postTypes)) {
        components[key.concat(formSufix)] = value.FormComponent;
    }
    return components;
}

function styleComponentsFn() {
    const components: { [key: string]: Component } = {};
    for (const [key, value] of Object.entries(postTypes)) {
        components[key.concat(styleSufix)] = value.StyleComponent;
    }
    return components;
}

function settingsComponentsFn() {
    const components: { [key: string]: Component } = {};
    for (const [key, value] of Object.entries(postTypes)) {
        if (value.SettingsComponent) {
            components[key.concat(settingsSufix)] = value.SettingsComponent;
        }
    }
    return components;
}

export const renderComponents = renderComponentsFn();
export const formComponents = formComponentsFn();
export const styleComponents = styleComponentsFn();
export const settingsComponents = settingsComponentsFn();

export function hasSettingsComponent(postType: string) {
    let hasSettingsComponent = false;
    for (const [key, value] of Object.entries(postTypes)) {
        if (key === postType && value.SettingsComponent) {
            hasSettingsComponent = true;
        }
    }
    return hasSettingsComponent;
}

export function getPostTypeTranslationKey(postType: string): string {
    switch (postType) {
    case "Grab":
        return "posts.Grab";
    case "Html":
        return "posts.Html";
    case "RSS":
        return "posts.RSS";
    case "Date":
        return "posts.Date";
    case "Image":
        return "posts.Image";
    case "Video":
        return "posts.Video";
    case "Folder":
        return "posts.Folder";
    case "Clock":
        return "posts.Clock";
    case "Wayfinder":
        return "posts.Wayfinder";
    case "FixedHtml":
        return "posts.FixedHtml";
    }
    throw Error("not a valid post type");
}

export function GetLocalizedItemTypes() {
    return Object.keys(postTypes)
        .map(key => ({ text: i18n.t(getPostTypeTranslationKey(key)), value: key }));
}

export function GetLocalizedStyleableTypes() {
    const items = [];
    for (const [key, value] of Object.entries(postTypes)) {
        if (value.StyleComponent.name) {
            items.push(key);
        }
    }
    return items.map(key => ({ text: i18n.t(getPostTypeTranslationKey(key)), value: key }));
}

export function GetLocalizedLanguages() {
    var languages = Languages;
    return languages
        .map(lang => ({ text: i18n.t(`languages.${lang.text}`), value: lang.code }));
}

export function GetLocalizedDateFormats() {
    var dateFormats = DateFormats;
    return dateFormats
        .map(format => ({ text: i18n.t(`dateFormats.${format.text}`), value: format.value }));
}

export function GetLocalizedClockFormats() {
    var clockFormats = ClockFormats;
    return clockFormats
        .map(format => ({ text: i18n.t(`clockFormats.${format.text}`), value: format.value }));
}

export function GetLocalizedHourFormats() {
    var hourFormats = HourFormatEnum;
    return Object.values(hourFormats)
        .map(val => ({ text: i18n.t(`clockFormats.${val}`), value: val }));
}
